import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'

const amountText = {
  fontSize: rf(48),
  letterSpacing: rw(-1.44),
  lineHeight: rh(53),
} as const

export const useCreateStyles = createStyleSheet((theme) => ({
  screen: { backgroundColor: theme.COLOR_BG_BASE, flexGrow: 1 },
  container: {
    backgroundColor: theme.COLOR_BG_BASE,
    gap: rh(40),
    paddingBottom: rh(64),
    paddingHorizontal: theme.SIZE_CONTAINER_PADDING,
    paddingTop: rh(24),
  },
  date: {
    color: theme.COLOR_TEXT_SECONDARY,
    fontSize: rf(16),
    lineHeight: rh(22),
    textAlign: 'center',
  },
  hero: { alignItems: 'center', gap: rh(32) },
  avatar: {
    alignItems: 'center',
    backgroundColor: theme.COLOR_BG_SURFACE,
    borderRadius: rw(40),
    height: rw(80),
    justifyContent: 'center',
    width: rw(80),
  },
  avatarLetter: {
    color: theme.COLOR_TEXT_SECONDARY,
    fontSize: rf(28),
    letterSpacing: rw(-0.56),
    lineHeight: rh(33.6),
  },
  bankAvatar: {
    borderRadius: rw(40),
    height: rw(80),
    width: rw(80),
    overflow: 'hidden',
  },
  bankAvatarSmall: { width: rw(24), height: rw(24), borderRadius: rw(12) },
  bankAvatarLogo: { width: '100%', height: '100%' },
  summary: { alignItems: 'center', gap: rh(12), width: '100%' },
  amount: { ...amountText, color: theme.COLOR_TEXT_PRIMARY },
  amountPending: { ...amountText, color: theme.COLOR_TEXT_DISABLED },

  amountCancelled: { ...amountText, color: theme.COLOR_TEXT_DISABLED, textDecorationLine: 'line-through' },
  amountSuccess: { ...amountText, color: theme.COLOR_TEXT_SUCCESS },
  refundNote: { backgroundColor: theme.COLOR_BG_SUCCESS, borderRadius: rw(12), padding: rw(12) },
  subtitle: { color: theme.COLOR_TEXT_SECONDARY, fontSize: rf(16), lineHeight: rh(22) },
  divider: { backgroundColor: theme.COLOR_STROKE_SECONDARY, height: rh(1), width: '100%' },
  details: { gap: rh(24) },
  sectionTitle: {
    color: theme.COLOR_TEXT_PRIMARY,
    fontSize: rf(20),
    letterSpacing: rw(-0.2),
    lineHeight: rh(26),
  },
  detailGroups: { gap: rh(32) },
  detailGroup: { gap: rh(16) },
  row: { alignItems: 'center', flexDirection: 'row', gap: rw(12), minHeight: rh(24) },
  rowLabel: { color: theme.COLOR_TEXT_SECONDARY, flex: 1, fontSize: rf(16), lineHeight: rh(22) },
  rowValue: { color: theme.COLOR_TEXT_PRIMARY, fontSize: rf(16), lineHeight: rh(22) },
  rowValueSuccess: { color: theme.COLOR_TEXT_SUCCESS, fontSize: rf(16), lineHeight: rh(22) },
  rowValueWarning: { color: theme.COLOR_TEXT_WARNING, fontSize: rf(16), lineHeight: rh(22) },
  rowValueCritical: { color: theme.COLOR_TEXT_CRITICAL, fontSize: rf(16), lineHeight: rh(22) },
  cardRow: { alignItems: 'center', flexDirection: 'row', gap: rw(12) },
  cardLabelBlock: { flex: 1, gap: rh(4) },
  bankValue: { alignItems: 'center', flexDirection: 'row', gap: rw(8) },
  idValue: { alignItems: 'center', flexDirection: 'row', gap: rw(4) },
  supportBlock: { gap: rh(24) },
  supportRow: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: rh(16),
  },
  supportContent: { alignItems: 'center', flexDirection: 'row', gap: rw(12) },
  supportText: { color: theme.COLOR_TEXT_PRIMARY, fontSize: rf(16), lineHeight: rh(22) },
}))
